import { ErrorBase } from '~/utils/error-base';

type ErrorName = 'POST_FORM_ERROR' | 'PARSE_COUPON_ERROR';

export class DiscountError extends ErrorBase<ErrorName> {}
